const urlUtils = {
    getFullApiHostname() {
        return `https://${this.getApiHostname()}`;
    },

    getApiHostname() {
        const host = window.location.hostname;
        let port = window.location.port.length > 1 ? `:${window.location.port}` : '';

        if (host === 'localhost') {
            port = ':5001';
        }

        return `${host}${port}`;
    },

    getUrlQueryParameter(location, param) {
        const params = new URLSearchParams(location.search);
        return params.get(param);
    }
};

export default urlUtils;
